import { render, staticRenderFns } from "./IOSProvider.vue?vue&type=template&id=07aafdff&"
import script from "./IOSProvider.vue?vue&type=script&lang=js&"
export * from "./IOSProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports